import type { FaireProductEntity } from "../../entity_types/product";

export const p_huvfs3mjk9: FaireProductEntity = {
  token: "p_huvfs3mjk9",
  type: "product",
  name: "Mandala Wooden Lazy Susan *",
  brandToken: "b_42bfa9c9",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/86c0118c0f740afd70fb3ec2087ecff5e25c47bb7f32d4c8d89dc97806ce9454.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16d0bb21afd0fe5aee51b03e4447641d9c2d6147ce40cd732cd9df7660782a97.jpeg",
    "https://cdn.faire.com/fastly/fd345db75aece1a0b7012807ceb508eea60204a373fa96264131681071ee3ace.jpeg",
    "https://cdn.faire.com/fastly/0de25785d41e3d0f8d7cb7af3407bb0285e7d7022f561bc882581b75ea071393.jpeg",
    "https://cdn.faire.com/fastly/0d96dde8f74c404dc9f24af79503d1d2da87cd4b1bdfb90c28f75947c031ce6b.jpeg",
    "https://cdn.faire.com/fastly/aa3e0b3196154c15cd8e1a93b8c5dc017799ddaca6bd02e2fdc6fa60eb1175d1.jpeg",
  ],
  priceDollars: 22.5,
  description:
    'Entertaining, organizing, keep items within reach with the sustainably handcrafted mango wood Mandala Wooden Lazy Susan. Crafted from sustainably grown mango wood, artisans of Noah\'s Ark in Moradabad, India carefully laser etch this hand drawn design with meticulous care. A work of art, the Mandala Wooden Lazy Susan is a perfect wedding or anniversary gift, a stunning centerpiece for meals enjoyed together. \t\n\n* Available only in the US - Materials: lasered mandala mango wood burn - Please note that this is made from different pieces of wood that may have slight shade variations. - Measures: 12"D x 2"H - Colors: Dark and light brown - Care: Wipe clean - UPC: 732919542868 - Handcrafted in India',
  tags: [],
  msrpDollars: 44.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.382Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
